(window.UploadKit = window.UploadKit || {}),
    (function (e, a) {
    
        function t(e, t, i, l, o, n) {
            var r = a.createElement("div");
            r.className = "uploadkit-field";
            var s = a.createElement("label");
            (s.className = "uploadkit-field-label"), (s.innerHTML = t.textFieldName);
            var d = a.createElement("textarea");
            (d.className = "uploadkit-textarea"), t.textFieldHelpText && (d.placeholder = t.textFieldHelpText), t.maxTextLength && t.maxTextLength > 0 && (d.maxLength = t.maxTextLength);
            var p = t.files.length > 1 ? " " + (o + 1) : "";
            (d.name = ("cart" === t.placement ? "attributes" : "properties") + "[" + (t.hiddenOnCheckout ? "_" : "") + (t.textFieldName > "" ? t.textFieldName : "Notes") + p + "]"),
                (d.dataset.uuid = i),
                l && (d.value = l),
                r.appendChild(s),
                r.appendChild(d),
                e.appendChild(r),
                d.addEventListener("input", function (e) {
                    m.handleTextChangeValidation(n);
                }),
                m.handleTextChangeValidation(n);
        }
        function i(e) {
            for (var a = [], t = 0; t < e.length; t++) {
                var i = e[t];
                m.mimeTypes[i] ? a.push(m.mimeTypes[i]) : a.push(i);
            }
            return a
                .filter(function (e, a, t) {
                    return t.indexOf(e) === a;
                })
                .join(", ");
        }
        function l(e, a, t) {
            if (t && e && a) {
                for (var i = [], l = 0; l < t.variants.length; l++) {
                    for (var o = [], n = 0; n < t.options.length; n++) o.push({ option: t.options[n], value: t.variants[l]["option" + (n + 1)] });
                    r(a, o) && i.push(t.variants[l].id);
                }
                (e.dataset.matchingVariantIds = i.join(",")), a.variantConditionType && "all_variants" !== a.variantConditionType && (e.dataset.matchVariants = "true");
            }
        }
        function o(e) {
            a.addEventListener("variantChange", m.variantChangeHandler.bind(e));
        }
        function n(e) {
            var t = m.findForm(e.parentElement);
            if (t && !t.dataset.formTriggerInterval) {
                var i = "[name=id],[name='id[]']",
                    l = t.querySelector(i) && t.querySelector(i).value;
                (t.dataset.formTriggerInterval = "true"),
                    setInterval(function () {
                        var e = t.querySelector(i) && t.querySelector(i).value;
                        if (e && e !== l) {
                            var o = new CustomEvent("variantChange");
                            a.dispatchEvent(o);
                        }
                        e && (l = e);
                    }, 500);
            }
        }
        function r(e, a) {
            if (
                !e.variantConditionType ||
                !e.variantConditions ||
                0 ===
                    e.variantConditions.filter(function (e) {
                        return null !== e.option;
                    }).length ||
                "all_variants" === e.variantConditionType
            )
                return !0;
            for (
                var t = 0;
                t <
                e.variantConditions.filter(function (e) {
                    return null !== e.option;
                }).length;
                t++
            ) {
                var i = e.variantConditions[t],
                    l = s(i, a);
                if ("or" === e.variantConditionType) {
                    if (l) return !0;
                } else if ("and" === e.variantConditionType) {
                    if (!l) return !1;
                } else if ("none" === e.variantConditionType && l) return !1;
            }
            return "or" !== e.variantConditionType && ("none" === e.variantConditionType || e.variantConditions.length > 0);
        }
        function s(e, a) {
            for (var t = 0; t < a.length; t++) if (a[t].option && e.option && a[t].option.toString().toLowerCase() === e.option.toString().toLowerCase() && u(e.operator, e.value, a[t].value)) return !0;
            return !1;
        }
        function d(e, a, t) {
            if ("cart" === e.placement) return !1;
            if (!a && !t) return !1;
            if ("all_products" === e.conditionType) return !0;
            for (var i = 0; i < e.conditions.length; i++) {
                var l = e.conditions[i],
                    o = p(l, a, t);
                if ("or" === e.conditionType) {
                    if (o) return !0;
                } else if ("and" === e.conditionType && !o) return !1;
            }
            return "or" !== e.conditionType && e.conditions.length > 0;
        }
        function p(e, a, t) {
            switch (e.field) {
                case "product":
                    for (var i = 0; i < e.products.length; i++) if (e.products[i].object_id.toString() === a.id.toString()) return !0;
                    break;
                case "collection":
                    for (var i = 0; i < e.collections.length; i++) for (var l = 0; l < t.length; l++) if (e.collections[i].object_id.toString() === t[l].id.toString()) return !0;
                    break;
                case "product_handle":
                    if (u(e.operator, e.value, a.handle)) return !0;
                    break;
                case "collection_handle":
                    for (var l = 0; l < t.length; l++) if (u(e.operator, e.value, t[l].handle)) return !0;
                    break;
                case "product_title":
                    if (u(e.operator, e.value, a.title)) return !0;
                    break;
                case "product_type":
                    if (u(e.operator, e.value, a.type)) return !0;
                    break;
                case "collection_title":
                    for (var l = 0; l < t.length; l++) if (u(e.operator, e.value, t[l].title)) return !0;
                    break;
                case "product_vendor":
                    if (u(e.operator, e.value, a.vendor)) return !0;
                    break;
                case "product_tags":
                    for (var o = Array.isArray(a.tags) ? a.tags : [], i = 0; i < e.tags.length; i++) for (var l = 0; l < o.length; l++) if (e.tags[i].toString().toLowerCase().trim() === o[l].toString().toLowerCase().trim()) return !0;
            }
            return !1;
        }
        function u(e, a, t) {
            if (t) return "equals" === e ? t.toString().toLowerCase().trim() === a.toString().toLowerCase().trim() : "contains" === e ? t.toString().toLowerCase().trim().indexOf(a.toString().toLowerCase().trim()) > -1 : void 0;
        }
        "function" != typeof Object.assign &&
            Object.defineProperty(Object, "assign", {
                value: function (e, a) {
                    "use strict";
                    if (null === e || void 0 === e) throw new TypeError("Cannot convert undefined or null to object");
                    for (var t = Object(e), i = 1; i < arguments.length; i++) {
                        var l = arguments[i];
                        if (null !== l && void 0 !== l) for (var o in l) Object.prototype.hasOwnProperty.call(l, o) && (t[o] = l[o]);
                    }
                    return t;
                },
                writable: !0,
                configurable: !0,
            }),
            Element.prototype.matches ||
                (Element.prototype.matches =
                    Element.prototype.matchesSelector ||
                    Element.prototype.mozMatchesSelector ||
                    Element.prototype.msMatchesSelector ||
                    Element.prototype.oMatchesSelector ||
                    Element.prototype.webkitMatchesSelector ||
                    function (e) {
                        for (var a = (this.document || this.ownerDocument).querySelectorAll(e), t = a.length; --t >= 0 && a.item(t) !== this; );
                        return t > -1;
                    }),
            (function () {
                function t(e, t) {
                    t = t || { bubbles: !1, cancelable: !1, detail: void 0 };
                    var i = a.createEvent("CustomEvent");
                    return i.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), i;
                }
                if ("function" == typeof e.CustomEvent) return !1;
                (t.prototype = e.Event.prototype), (e.CustomEvent = t);
            })();
        var m = e.UploadKit;
        (m.createStylesheet = function () {
            return (function () {
                var e = a.createElement("style");
                return e.appendChild(a.createTextNode("")), a.head.appendChild(e), e.sheet;
            })();
        }),
            (m.setupStylesheet = function () {
                var a = m.createStylesheet();
                a.insertRule(".uploadkit { width: 100%; clear: both; }", 0),
                    a.insertRule(".uploadkit-label { font-size: 16px; display: block; margin-bottom: 8px; line-height: 1.25; font-style: normal; }", 0),
                    a.insertRule(
                        ".uploadkit-button { height: auto; line-height: 1.4; border: none; border-radius: 3px; font-size: 16px; padding: 8px 16px; background-color: #00a3f0; color: #FFF; margin-bottom: 20px; font-weight: bold; cursor: pointer; }",
                        0
                    ),
                    a.insertRule(".uploadkit-button:hover { border: none; background-color: #00a3f0; color: #FFF; }", 0),
                    a.insertRule(".uploadkit-button-full-width { width: 100%; }", 0),
                    a.insertRule(".uploadkit-thumbnails { max-width: 300px; margin: 0 0 10px; }", 0),
                    a.insertRule(".uploadkit-thumbnails img.uploadkit-thumbnail { width: auto; max-height: 250px; max-width: 100%; height: auto; background-color: #E8E8E8; cursor: pointer; }", 0),
                    a.insertRule(".uploadkit-thumbnails .uploadkit-file-listing { display: flex; flex-direction: row; margin-bottom: 10px; align-items: center; }", 0),
                    a.insertRule(".uploadkit-thumbnails .uploadkit-file-listing span { font-size: 14px; flex-grow: 1; }", 0),
                    a.insertRule(".uploadkit-thumbnails img.uploadkit-fileicon { cursor: default; margin-right: 8px; height: 30px; width: 30px; align-self: flex-start; flex-grow: 0; }", 0),
                    a.insertRule(".uploadkit-field label.uploadkit-field-label { text-align: left; display: block; font-size: 14px; margin-top: 0; margin-bottom: 5px; text-transform: none; line-height: 16px; }", 0),
                    a.insertRule(
                        ".uploadkit-field textarea.uploadkit-textarea { font-size: 14px; text-transform: none; line-height: 16px; background-color: white; color: #333; border: 1px solid #6666; padding: 5px 10px; height: auto; outline: none; margin-top: 0; margin-bottom: 25px; width: 100%; height: 48px; }",
                        0
                    );
                try {
                    a.insertRule(".uploadkit-field textarea.uploadkit-textarea::-webkit-input-placeholder { color: #999999; }", 0);
                } catch (e) {}
                try {
                    a.insertRule(".uploadkit-field textarea.uploadkit-textarea::-moz-placeholder { color: #999999; }", 0);
                } catch (e) {}
                try {
                    a.insertRule(".uploadkit-field textarea.uploadkit-textarea:-ms-input-placeholder { color: #999999; }", 0);
                } catch (e) {}
                a.insertRule(".uploadkit-progressbar { width: 100%; border-radius: 25px; height: 20px; margin-bottom: 10px; background-color: #E3E3E3; }", 0);
                try {
                    a.insertRule(
                        ".uploadkit-progress { background-color: #00A3F0; height: 20px; display: inline-block; border-radius: 25px; min-width: 20px; -webkit-animation: pulse 2.5s infinite ease-in-out; -ms-animation: pulse 2.5s infinite ease-in-out; -moz-animation: pulse 2.5s infinite ease-in-out; animation: pulse 2.5s infinite ease-in-out; transition: width 500ms ease-in-out; }",
                        0
                    );
                } catch (e) {}
                try {
                    a.insertRule("@keyframes pulse { 0% { opacity: 0.65; } 50% { opacity: 1; } 100% { opacity: 0.65; }}", 0);
                } catch (e) {}
                a.insertRule(
                    ".uploadcare--panel_multiple .uploadcare--preview__content:before { box-sizing: border-box; text-align: left !important; display: block; width: 100%; padding: 10px 20px; background-color: #F0F0F0; margin-bottom: 10px; font-size: 16px; font-weight: bold; }",
                    0
                );
                try {
                    a.insertRule(".uploadcare--crop-widget + .uploadkit-overlay-preview { display: none; }", 0);
                } catch (e) {}
                try {
                    a.insertRule(".uploadcare--jcrop-tracker:first-of-type { opacity: 1 !important; background-color: transparent !important;", 0);
                } catch (e) {}
                try {
                    a.insertRule('.uploadcare--jcrop-tracker::after { content: ""; position: absolute; width: 100%; height: 100%; left: 0; top: 0; background-size: cover; background-position: center center; }', 0);
                } catch (e) {}
                return (
                    a.insertRule(".uploadcare--powered-by { display: none !important; }", 0),
                    a.insertRule(".uploadkit-invalid .shopify-payment-button { opacity: 0.25; pointer-events: none !important; }", 0),
                    a.insertRule(".uploadkit-form:not(.uploadkit-invalid) .uploadkit-cloned-atc-button { display: none !important; }", 0),
                    a.insertRule(".uploadkit-invalid .uploadkit-original-atc-button { display: none !important; }", 0),
                    a.insertRule(".uploadkit-invalid .uploadkit-cloned-atc-button { display: block; }", 0),
                    a.insertRule(".uploadkit-invalid-message { display: none; }", 0),
                    a.insertRule(".uploadkit-invalid .uploadkit-invalid-message { display: block; }", 0),
                    a.insertRule(".uploadcare--jcrop-hline.bottom { transform: none; background-color: transparent; }", 0),
                    a.insertRule("[data-pf-type=UploadKit] .uploadkit-thumbnails { display: block !important; }", 0),
                    a.insertRule("body.instagram-app .uploadcare--footer, body.facebook-app .uploadcare--footer { padding-bottom: 75px; }", 0),
                    a.insertRule("label.uploadkit-android-fb-message { display: block; font-size: 14px; margin-bottom: 20px; }", 0),
                    a.insertRule(".uploadcare--crop-widget div:empty, .uploadcare--crop-sizes__icon:empty { display: block; }", 0),
                    e.UploadKit && e.UploadKit.config && !1 !== e.UploadKit.config.whiteLabel && a.insertRule(".uploadcare--uploadkit-powered-by { display: none !important; }", 0),
                    a
                );
            }),
            (m.refreshUploader = function (e) {
                for (var i = 0; i < m.containers.length; i++) {
                    var l = m.containers[i];
                    m.refreshFormRequiredValidation(l);
                    for (var o = l.querySelectorAll(".uploadkit-uploader[data-uploader-id='" + e.id + "'] textarea.uploadkit-textarea"), n = 0; n < o.length; n++)
                        o[n].dataset.uuid > "" && (m.textFields[o[n].dataset.uuid] = o[n].value), 0 === n && o[0].value > "" && (e.firstTextField = o[0].value);
                    for (var r = l.querySelector(".uploadkit-uploader[data-uploader-id='" + e.id + "'] .uploadkit-thumbnails"); r && r.firstChild; ) r.removeChild(r.firstChild);
                    for (var s = l.querySelector(".uploadkit-uploader[data-uploader-id='" + e.id + "'] .uploadkit-initial-text-field"); s && s.firstChild; ) s.removeChild(s.firstChild);
                    for (var d = l.querySelector(".uploadkit-uploader[data-uploader-id='" + e.id + "'] .uploadkit-attribute-container"); d && d.firstChild; ) d.removeChild(d.firstChild);
                    if (r && d) {
                        var p = [],
                            u = [];
                        0 === e.files.length && (e.alwaysShowTextField || m.alwaysShowTextField) && t(s, e, null, e.firstTextField, 0, l);
                        for (var c = 0; c < e.files.length; c++) {
                            var f = e.files[c].fileInfo;
                            if (f) {
                                if (f.isImage && !m.alwaysDisplayIcons) {
                                    var g = a.createElement("img");
                                    g.className = "uploadkit-thumbnail";
                                    var k = "";
                                    e.enableOverlay &&
                                        e.overlayUuid &&
                                        ((k = "-/overlay/" + e.overlayUuid + "/100px100p/center/"), f.cdnUrlModifiers && -1 === f.cdnUrlModifiers.indexOf("-/overlay/") && (f.cdnUrlModifiers = f.cdnUrlModifiers + k)),
                                        (g.src = f.cdnUrl.replace("-/preview/", "").replace(/\-\/resize\/[^\/]*\//g, "") + k + "-/resize/300x/"),
                                        f.originalImageInfo && ((g.width = f.originalImageInfo.width), (g.height = f.originalImageInfo.height)),
                                        g.addEventListener("click", m.openUploadDialog.bind(e)),
                                        r.appendChild(g);
                                } else {
                                    var v = a.createElement("div");
                                    v.className = "uploadkit-file-listing";
                                    var g = a.createElement("img");
                                    (g.width = 30), (g.height = 30), (g.className = "uploadkit-fileicon"), (g.src = m.config.assetsBaseUri + "/assets/images/icons/" + (m.mimeTypes[f.mimeType] || "blank") + ".svg"), v.appendChild(g);
                                    var h = a.createElement("span");
                                    h.appendChild(a.createTextNode(f.name)), v.appendChild(h), r.appendChild(v);
                                }
                                if (e.enableTextField) {
                                    var b = m.textFields[f.uuid];
                                    !b && 0 == c && e.firstTextField && (b = e.firstTextField), t(r, e, f ? f.uuid : null, b, c, l);
                                }
                                var y, x;
                                f.originalImageInfo && ((y = f.originalImageInfo.width), (x = f.originalImageInfo.height));
                                var z = f.cdnUrlModifiers;
                                z && Shopify && "pixforhome.myshopify.com" === Shopify.shop && (z = z.replace(/\-\/resize\/[^\/]*\//g, "")),
                                    p.push(
                                        m.config.previewBaseUri +
                                            "?id=" +
                                            m.config.shopId +
                                            "&uu=" +
                                            f.uuid +
                                            "&mo=" +
                                            (z || "") +
                                            "&fi=" +
                                            btoa(f.name.replace(/[^\.\w\s-]/gi, "")) +
                                            (y ? "&wi=" + y : "") +
                                            (x ? "&he=" + x : "") +
                                            (f.mimeType ? "&mi=" + btoa(f.mimeType) : "") +
                                            (f.isImage ? "&image=true" : "")
                                    ),
                                    m && m.constructDirectFileLink
                                        ? u.push(m.constructDirectFileLink.call(this, f))
                                        : u.push(
                                              m.config.filesBaseUri +
                                                  "/" +
                                                  m.config.shopId +
                                                  "/" +
                                                  f.uuid +
                                                  "/" +
                                                  (z || "") +
                                                  encodeURIComponent(f.name) +
                                                  (f.isImage ? "?image" : "") +
                                                  (m.directDownload ? (f.isImage ? "&dl=1" : "?dl=1") : "")
                                          );
                            } else {
                                var w = a.createElement("div");
                                w.className = "uploadkit-progressbar";
                                var T = a.createElement("span");
                                (T.className = "uploadkit-progress"), w.appendChild(T), r.appendChild(w), (e.files[c].progressEl = T);
                            }
                        }
                        var S = l.querySelector(".uploadkit-uploader[data-uploader-id='" + e.id + "'] .uploadkit-button");
                        p.length > 0 && e.buttonUploadedText > ""
                            ? S &&
                              ((S.innerHTML = '<div><span class="custom-upload-title">Upload your Artwork</span><svg class="custom-upload-svg" width="28" height="19" viewBox="0 0 28 19" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.2"><rect x="3.11719" y="6.16016" width="12.6" height="12.32" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M20.6449 7.53318C20.6437 7.58843 20.6417 7.64368 20.6392 7.69862C21.2312 7.4765 21.8716 7.35511 22.5401 7.35511C25.5555 7.35511 28 9.82491 28 12.8716C28 15.9183 25.5555 18.3881 22.5401 18.3881C22.5133 18.3881 22.4865 18.3879 22.4597 18.3874C22.4397 18.3871 22.4199 18.3868 22.4001 18.3863V18.3881H14.1185V9.90279L17.5151 13.3773C17.7999 13.6687 18.2616 13.6687 18.5465 13.3773C18.8313 13.086 18.8313 12.6135 18.5465 12.3221L13.9049 7.57391C13.6201 7.28249 13.1583 7.28249 12.8735 7.57391L8.23196 12.3221C7.94727 12.6135 7.94727 13.086 8.23196 13.3773C8.5168 13.6687 8.97867 13.6687 9.26351 13.3773L12.6599 9.90279V18.3881H6.43994V18.3866C2.87061 18.3113 0 15.3643 0 11.7402C0 8.1167 2.86933 5.17013 6.43754 5.09375C7.38189 2.13801 10.1273 0 13.3667 0C17.3874 0 20.6466 3.29307 20.6466 7.3553C20.6466 7.41482 20.646 7.47417 20.6446 7.53337L20.6449 7.53318Z" fill="#555555"/></g></svg></br><span class="custom_drag_drop">JPEG, PNG</span></br><span class="choose-file-btn">Choose file</span></div>'
                                  .replace(/{{\s*number\s*}}/g, p.length)
                                  .replace(/{%\s*singular\s*%}(.*){%\s*endsingular\s*%}/, 1 === p.length ? "$1" : "")
                                  .replace(/{%\s*plural\s*%}(.*){%\s*endplural\s*%}/, p.length > 1 ? "$1" : "")),
                              (S.className = S.className.replace("uploadkit-button-uploaded", "") + " uploadkit-button-uploaded"))
                            : S && ((S.innerHTML = e.buttonText), (S.className = S.className.replace("uploadkit-button-uploaded", "")));
                        for (var c = 0; c < p.length; c++) {
                            var j = p.length > 1 ? " " + (c + 1) : "",
                                F = a.createElement("input");
                            if (((F.type = "hidden"), (F.name = ("cart" === e.placement ? "attributes" : "properties") + "[" + (e.hiddenOnCheckout ? "_" : "") + e.name + j + "]"), (F.value = p[c]), d.appendChild(F), e.enableDirectLink)) {
                                var I = a.createElement("input");
                                (I.type = "hidden"), (I.name = ("cart" === e.placement ? "attributes" : "properties") + "[_" + e.name + j + " (direct link)]"), (I.value = u[c]), d.appendChild(I);
                            }
                        }
                        m.callbacks && m.callbacks.afterRefresh && m.callbacks.afterRefresh({ el: l, uploader: e, files: e.files });
                    }
                }
            }),
            (m.handleTextChangeValidation = function (e) {
                var a = m.findForm(e);
                a &&
                    (m.containerTextInvalidUploaders(e).length > 0 || m.containerInvalidUploaders(e).length > 0
                        ? -1 === a.className.indexOf("uploadkit-invalid") && (a.className = a.className + " uploadkit-invalid")
                        : (a.className = a.className.replace("uploadkit-invalid", "")));
            }),
            (m.variantChangeHandler = function () {
                m.setActiveForCurrentVariant.call(this), m.addFormRequiredValidation(m.containers);
            }),
            (m.setActiveForCurrentVariant = function () {
                var e = this;
                if ("true" === e.dataset.matchVariants) {
                    var a = m.findForm(e.parentElement);
                    if (a) {
                        var t = a.querySelector("[name=id],[name='id[]']") && a.querySelector("[name=id],[name='id[]']").value;
                        if (void 0 !== t && null !== t) {
                            t > "" && e.dataset.matchingVariantIds.toLowerCase().split(",").indexOf(t.toString().toLowerCase()) > -1
                                ? ((e.dataset.active = "true"), (e.style.display = "block"))
                                : ((e.dataset.active = "false"), (e.style.display = "none"));
                            for (var i = e.querySelectorAll("input, textarea"), l = 0; l < i.length; l++) i[l].disabled = "true" === e.dataset.active ? "" : "disabled";
                        }
                    }
                }
            }),
            (m.fileUploaded = function (e) {
                (this.file.fileInfo = e), m.refreshUploader(this.uploader);
                var a = new XMLHttpRequest(),
                    t = {};
                (t.shop_id = m.config.shopId),
                    (t.uuid = e.uuid),
                    (t.file_info = e),
                    (t.text_field_value = m.textFields[t.uuid]),
                    a.open("POST", m.config.apiBaseUri + "/api/uploads", !0),
                    a.setRequestHeader("Content-Type", "application/json"),
                    a.send(JSON.stringify(t)),
                    m.callbacks && m.callbacks.afterFileUploaded && m.callbacks.afterFileUploaded({ uploader: this.uploader, uploadedFile: this.file });
            }),
            (m.assignFilesToUploader = function (e) {
                if (e.fileObject)
                    if (((e.files = []), m.refreshUploader(e), "function" == typeof e.fileObject.files)) for (var a = e.fileObject.files(), t = 0; t < a.length; t++) m.assignFile.call(e, a[t]);
                    else if (Array.isArray(e.fileObject)) for (var t = 0; t < e.fileObject.length; t++) m.assignFile.call(e, e.fileObject[t]);
                    else m.assignFile.call(e, e.fileObject);
            }),
            (m.assignFile = function (e) {
                if ("rejected" !== e.state()) {
                    var a = this,
                        t = { ucObject: e, fileInfo: null, uploadInfo: null };
                    a.files.push(t),
                        t.ucObject.promise().done(m.fileUploaded.bind({ uploader: a, file: t })),
                        m.refreshUploader(a),
                        t.ucObject.progress(function (e) {
                            (t.uploadInfo = e), t.progressEl && (t.progressEl.style.width = 100 * e.progress + "%");
                        });
                }
            }),
            (m.applyUploadDialogStyles = function (e) {
                try {
                    if (!m.previewMessageStylesheet) return;
                    for (; m.previewMessageStylesheet.cssRules.length; ) m.previewMessageStylesheet.deleteRule(0);
                    e.previewMultipleMessageDesktop && e.previewMultipleMessageDesktop.length > 0
                        ? m.previewMessageStylesheet.insertRule('@media (min-width: 760px) { .uploadcare--panel_multiple .uploadcare--preview__content:before { content: "' + e.previewMultipleMessageDesktop.replace(/"/g, '"') + '"; } }', 0)
                        : (null !== e.previewMultipleMessageDesktop && void 0 !== e.previewMultipleMessageDesktop) ||
                          m.previewMessageStylesheet.insertRule(
                              '@media (min-width: 760px) { .uploadcare--panel_multiple .uploadcare--preview__content:before { content: "Choose an image from the list to crop or enhance it. To add more files, use the links on the left"; } }',
                              0
                          ),
                        e.previewMultipleMessageMobile && e.previewMultipleMessageMobile.length > 0
                            ? m.previewMessageStylesheet.insertRule(
                                  '@media (max-width: 759px) { .uploadcare--panel_multiple .uploadcare--preview__content:before { content: "' + e.previewMultipleMessageMobile.replace(/"/g, '"') + '"; } }',
                                  0
                              )
                            : (null !== e.previewMultipleMessageMobile && void 0 !== e.previewMultipleMessageMobile) ||
                              m.previewMessageStylesheet.insertRule(
                                  '@media (max-width: 759px) { .uploadcare--panel_multiple .uploadcare--preview__content:before { content: "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left"; } }',
                                  0
                              );
                } catch (e) {
                    console.log("Error applying dialog styles:", e);
                }
            }),
            (m.openUploadDialog = function (t) {
                if ((m.debug && console.log("UploadKit: Open upload dialog", t), m.callbacks && m.callbacks.afterOpenUploadDialog && m.callbacks.afterOpenUploadDialog.apply(this), t && t.preventDefault(), e.uploadcare)) {
                    var i = this,
                        l = m.generateSettings(i);
                    m.loadTranslationsForUploader(i),
                        m.applyUploadDialogStyles(i),
                        (observePreviewImageLoadHandler = function (e) {
                            var t = a.getElementById("uploadkit-cropper-style");
                            if ((t && (t.innerHTML = ""), i.enableOverlay && i.overlayUuid)) {
                                if (!t) {
                                    var t = a.createElement("style");
                                    (t.id = "uploadkit-cropper-style"), (t.type = "text/css"), a.head.appendChild(t);
                                }
                                if (
                                    (t.appendChild(a.createTextNode(".uploadcare--jcrop-tracker::after,.uploadcare--file__preview::after{background-image: url(https://ucarecdn.com/" + i.overlayUuid + "/);}")),
                                    e.target && -1 !== e.target.className.indexOf("uploadcare--preview__image") && -1 !== e.target.src.indexOf("/crop/") && -1 === e.target.src.indexOf("/overlay/"))
                                ) {
                                    var l = a.querySelector(".uploadcare-tab-effects--image-container"),
                                        o = l.querySelector(".uploadkit-overlay-preview");
                                    null != o && l.removeChild(o);
                                    var n = a.createElement("img");
                                    n.classList.add("uploadkit-overlay-preview"), n.classList.add("uploadcare--media__image"), (n.src = e.target.src + "-/overlay/" + i.overlayUuid + "/100.5px100.5p/center/"), l.appendChild(n);
                                }
                            }
                        }.bind(this)),
                        a.body.addEventListener("load", observePreviewImageLoadHandler, !0);
                    var o = e.uploadcare.openDialog(i.fileObject, l);
                    o.done(function (e) {
                        (i.fileObject = e), m.assignFilesToUploader(i), m.callbacks && m.callbacks.dialogDone && m.callbacks.dialogDone({ uploader: i });
                    }),
                        o.fail(function (e) {
                            (i && i.effects && i.effects.indexOf("crop") > -1 && -1 === i.cropSetting.indexOf("free")) || ((i.fileObject = e), m.assignFilesToUploader(i));
                        }),
                        o.always(function (e) {
                            a.body.removeEventListener("load", observePreviewImageLoadHandler);
                        });
                }
            }),
            (m.addFilesFromUrls = function (a, t) {
                if (e.uploadcare) {
                    var i = m.generateSettings(a);
                    "string" == typeof t && (t = [t]);
                    var l = e.uploadcare.filesFrom("url", t, i);
                    a.fileObject = l;
                    for (var o = 0; o < l.length; o++) m.assignFile.call(a, l[o]);
                    return l;
                }
            }),
            (m.addFilesFromBlobs = function (a, t, i) {
                if (e.uploadcare) {
                    var l = m.generateSettings(a);
                    void 0 === t.length && (t = [t]);
                    var o = e.uploadcare.filesFrom("object", t, l);
                    a.fileObject = o;
                    for (var n = 0; n < o.length; n++) m.assignFile.call(a, o[n]);
                    return o;
                }
            }),
            (m.addFilesFromUuids = function (a, t) {
                if (e.uploadcare) {
                    var i = m.generateSettings(a);
                    "string" == typeof t && (t = [t]);
                    var l = e.uploadcare.filesFrom("uploaded", t, i);
                    a.fileObject = l;
                    for (var o = 0; o < l.length; o++) m.assignFile.call(a, l[o]);
                    return l;
                }
            }),
            (m.loadTranslationsForUploader = function (a) {
                e.UPLOADCARE_LOCALE = m.language || a.language || "en";
                for (var t = {}, l = 0; l < a.validators.length; l++)
                    a.validators[l] && "minimumImageSize" === a.validators[l].type && (t.minimumImageSize = a.validators[l].args),
                        a.validators[l] && "fileTypes" === a.validators[l].type && (t.fileTypes = i(a.validators[l].args[0])),
                        a.validators[l] && "maximumFileSize" === a.validators[l].type && (t.maximumFileSize = a.validators[l].args);
                (e.UPLOADCARE_LOCALE_TRANSLATIONS = f(t, e.UPLOADCARE_LOCALE)),
                    (e.UPLOADCARE_LOCALE_PLURALIZE = c(e.UPLOADCARE_LOCALE)),
                    e.UploadKit.customTranslations && e.UploadKit.customTranslations[e.UPLOADCARE_LOCALE] && Object.assign(e.UPLOADCARE_LOCALE_TRANSLATIONS, e.UploadKit.customTranslations[e.UPLOADCARE_LOCALE]);
            }),
            (m.generateSettings = function (e) {
                var a = [];
                e.validators &&
                    (a = e.validators.map(function (a) {
                        return m.validators[a.type].apply(e, a.args ? a.args : []);
                    })),
                    m.customValidators && (a = a.concat(m.customValidators));
                var t = {
                    publicKey: m.config.ucKey,
                    previewStep: !0,
                    multiple: e.multiple,
                    tabs: e.sources,
                    imagesOnly: e.imagesOnly,
                    multipleMax: e.multipleMax || 0,
                    multipleMin: e.multipleMin || 0,
                    crop: e.cropSetting,
                    effects: e.effects,
                    autoOpenFilePicker: e.autoOpenFilePicker,
                    validators: a,
                    locale: m.language || e.language || "en",
                };
                return e.inputAcceptTypes.length > 0 && (t.inputAcceptTypes = e.inputAcceptTypes), t.imagesOnly && !t.inputAcceptTypes && ((t.imagesOnly = !1), (t.inputAcceptTypes = "image/*")), t;
            }),
            (m.findOrCreateContainers = function () {
                var e = [],
                    t = a.querySelectorAll("div.uploadkit, div.uploadkit-cart");
                if (t.length > 0) e = t;
                else {
                    var i;
                    i = m.formSelector ? a.querySelectorAll(m.formSelector) : a.querySelectorAll("form[action*='/cart/add']");
                    for (var l = 0; l < i.length; l++) {
                        var o = i[l];
                        if (!(o.getAttribute("id") && o.getAttribute("id").indexOf("installment") > -1)) {
                            var n = o.querySelector(
                                    ".desc_blk_bot,.product-actions-row,.product-form__item--quantity,.groups-btn,.product_payments_btns,.single_variation_wrap,.row_grid_qnt,#CartButtons-product,.product-form__payment-container,.left.product-quantity-box,.shopify-variation-add-to-cart,.product-quantity-container,.d-flex,.product-form--atc,.selection-wrapper.cart,.addtocart--button, .purchase-details,[type=submit],.add_to_cart,.btn.add-to-cart,.shopify-payment-button,.add-to-cart-btn,.button--add-to-cart,.product-form__cart-submit,.gt_button[attribute=addToCart],.button--addToCart,button[data-attribute=productButtonAddToCart],.gt_product-button,.product-area .product-detail__form__action,.product-submit.action-button"
                                ),
                                r = a.createElement("div");
                            (r.className = "uploadkit uploadkit-injected test321"), n ? n.parentNode.insertBefore(r, n) : o.insertBefore(r, o.firstChild), e.push(r);
                        }
                    }
                }
                return e;
            }),
            (m.resetUploaders = function () {
                if (m.config && m.config.uploaders)
                    for (var e = 0; e < m.config.uploaders.length; e++) {
                        var a = m.config.uploaders[e];
                        (a.fileObject = null), (a.files = []), m.refreshUploader(a);
                    }
            }),
            (m.validators = {
                fileTypes: function (e) {
                    return function (a) {
                        if (a.mimeType && e && 0 !== e.length && (1 !== e.length || "image/*" !== e[0])) {
                            for (var t = !1, i = 0; i < e.length; i++)
                                if (e[i].indexOf("/*") > -1) a.mimeType && e[i].split("/")[0].toLowerCase() === a.mimeType.split("/")[0].toLowerCase() && (t = !0);
                                else if (e[i].indexOf("/") > -1) a.mimeType && e[i].toLowerCase() === a.mimeType.toLowerCase() && (t = !0);
                                else {
                                    var l = a.name.split(".");
                                    l[l.length - 1].toLowerCase() == e[i].toLowerCase().replace(".", "") && (t = !0);
                                }
                            if (!t) throw new Error("fileTypes");
                        }
                    };
                },
                imagesOnly: function () {
                    return function (e) {
                        if (!1 === e.isImage && (!e.mimeType || -1 === e.mimeType.indexOf("image"))) throw new Error("imagesOnly");
                    };
                },
                minimumImageSize: function (e, a) {
                    return function (t) {
                        var i = t.crop && t.crop.height && t.crop.width ? t.crop : t.originalImageInfo;
                        if (null !== i && (Math.min(i.width, i.height) < Math.min(e, a) || Math.max(i.width, i.height) < Math.max(e, a))) throw new Error("imageTooSmall");
                    };
                },
                maximumFileSize: function (e) {
                    return function (a) {
                        if (a.size > 1024 * e * 1024) throw new Error("filesize");
                    };
                },
            }),
            (m.renderUploaders = function (i, r) {
                for (var s = 0; s < i.length; s++)
                    for (var p = i[s], u = 0; u < r.length; u++) {
                        var c = r[u];
                        if (((c.files = []), !e.UploadKit.multiLanguage || e.UploadKit.currentLanguage === c.language)) {
                            var f = m.product,
                                g = m.collections;
                            if (p.dataset.productJson > "" && p.dataset.collectionsJson > "")
                                try {
                                    (f = JSON.parse(p.dataset.productJson)), (g = JSON.parse(p.dataset.collectionsJson));
                                } catch (e) {}
                            if (p.dataset.uploadkitProductJson > "" && p.dataset.uploadkitCollectionsJson > "")
                                try {
                                    (f = JSON.parse(p.dataset.uploadkitProductJson)), (g = JSON.parse(p.dataset.uploadkitCollectionsJson));
                                } catch (e) {}
                            if (d(c, f, g) && (m.activeUploaders && -1 === m.activeUploaders.indexOf(c) && m.activeUploaders.push(c), !(p.querySelectorAll(".uploadkit-uploader[data-uploader-id='" + c.id + "']").length > 0))) {
                                var k = a.createElement("div");
                                if (((k.className = "uploadkit-uploader"), (k.dataset.uploaderId = c.id), (k.dataset.uploaderLanguage = c.language), (k.dataset.active = "true"), c.formLabelText && c.formLabelText.length > 0)) {
                                    var v = a.createElement("label");
                                    (v.className = "uploadkit-label"), (v.innerHTML = c.formLabelText), c.formLabelFontSize && c.formLabelFontSize.length > 0 && (v.style.fontSize = c.formLabelFontSize), k.appendChild(v);
                                }
                                var h = a.createElement("div");
                                (h.className = "uploadkit-attribute-container"), k.appendChild(h);
                                var b = a.createElement("div");
                                (b.className = "uploadkit-thumbnails"), k.appendChild(b);
                                var y = a.createElement("button");
                                if (
                                    ((y.className = "uploadkit-button custom-upload-btn"),
                                    c.buttonFullWidth && (y.className = y.className + " uploadkit-button-full-width"),
                                    (y.dataset.uploaderName = c.name),
                                    (y.dataset.uploaderId = c.id),
                                    (y.type = "button"),
                                    c.buttonCss && c.buttonCss.length > 0 && (y.style.cssText = c.buttonCss),
                                    c.buttonBackgroundColor && c.buttonBackgroundColor.length > 0 && (y.style.backgroundColor = c.buttonBackgroundColor),
                                    c.buttonColor && c.buttonColor.length > 0 && (y.style.color = c.buttonColor),
                                    c.buttonPadding && c.buttonPadding.length > 0 && (y.style.padding = c.buttonPadding),
                                    c.buttonFontSize && c.buttonFontSize.length > 0 && (y.style.fontSize = c.buttonFontSize),
                                    c.buttonBorderRadius && c.buttonBorderRadius.length > 0 && (y.style.borderRadius = c.buttonBorderRadius),
                                    (y.innerHTML = '<div><span class="custom-upload-title">Upload your Artwork</span><svg class="custom-upload-svg" width="28" height="19" viewBox="0 0 28 19" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.2"><rect x="3.11719" y="6.16016" width="12.6" height="12.32" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M20.6449 7.53318C20.6437 7.58843 20.6417 7.64368 20.6392 7.69862C21.2312 7.4765 21.8716 7.35511 22.5401 7.35511C25.5555 7.35511 28 9.82491 28 12.8716C28 15.9183 25.5555 18.3881 22.5401 18.3881C22.5133 18.3881 22.4865 18.3879 22.4597 18.3874C22.4397 18.3871 22.4199 18.3868 22.4001 18.3863V18.3881H14.1185V9.90279L17.5151 13.3773C17.7999 13.6687 18.2616 13.6687 18.5465 13.3773C18.8313 13.086 18.8313 12.6135 18.5465 12.3221L13.9049 7.57391C13.6201 7.28249 13.1583 7.28249 12.8735 7.57391L8.23196 12.3221C7.94727 12.6135 7.94727 13.086 8.23196 13.3773C8.5168 13.6687 8.97867 13.6687 9.26351 13.3773L12.6599 9.90279V18.3881H6.43994V18.3866C2.87061 18.3113 0 15.3643 0 11.7402C0 8.1167 2.86933 5.17013 6.43754 5.09375C7.38189 2.13801 10.1273 0 13.3667 0C17.3874 0 20.6466 3.29307 20.6466 7.3553C20.6466 7.41482 20.646 7.47417 20.6446 7.53337L20.6449 7.53318Z" fill="#555555"/></g></svg></br><span class="custom_drag_drop">JPEG, PNG</span></br><span class="choose-file-btn">Choose file</span></div>'),
                                    k.appendChild(y),
                                    c.androidFbMessage && c.androidFbMessage.length > 0 && navigator.userAgent.match(/instagram|FBAN|FBAV|Snapchat/i) && navigator.userAgent.match(/android/i))
                                ) {
                                    var v = a.createElement("label");
                                    (v.className = "uploadkit-android-fb-message"),
                                        (v.innerHTML = c.androidFbMessage
                                            .replace("⋮", '&nbsp;<strong style="display: inline-block; transform: scale(1.5);">⋮</strong>&nbsp;')
                                            .replace("{icon}", '&nbsp;<strong style="display: inline-block; transform: scale(1.5);">⋮</strong>&nbsp;')),
                                        k.appendChild(v);
                                }
                                var x = a.createElement("div");
                                if (
                                    ((x.className = "uploadkit-initial-text-field"),
                                    k.appendChild(x),
                                    (c.alwaysShowTextField || m.alwaysShowTextField) && t(x, c, null, c.firstTextField, 0, p),
                                    p.appendChild(k),
                                    l(k, c, f),
                                    o(k),
                                    n(k),
                                    m.setActiveForCurrentVariant.call(k),
                                    c.customCss && c.customCss.length > 0)
                                ) {
                                    var z = a.createElement("style");
                                    z.appendChild(a.createTextNode(c.customCss)), a.head.appendChild(z);
                                }
                                if ("cart" === c.placement && m.cart && m.cart.attributes) {
                                    for (var w = new RegExp(/https:\/\/cdn2?\.shopify\.com\/.*\?.*id=[^&]*&uu=([^&]*)&mo=([^&]*)&fi=([^&]*)(&image=true)?/, "g"), T = Object.keys(m.cart.attributes), S = [], j = 0; j < T.length; j++)
                                        if (T[j].indexOf(c.name) > -1) {
                                            var F = m.cart.attributes[T[j]];
                                            if (F) {
                                                var I = w.exec(F);
                                                I && S.push(I[1]);
                                            }
                                        }
                                    S.length > 0 &&
                                        (e.uploadcare
                                            ? m.addFilesFromUuids(c, S)
                                            : (m.afterUploadcareInitialized = function () {
                                                  m.addFilesFromUuids(c, S);
                                              }));
                                }
                                if (m.clickListenersOnDocument) {
                                    var C = ".uploadkit-uploader[data-uploader-id='" + c.id + "']";
                                    a.addEventListener("click", function (e) {
                                        e.target.closest(".uploadkit-button") && e.target.closest(C) && ((m.containers = m.findOrCreateContainers()), m.openUploadDialog.call(c));
                                    }),
                                        m.debug && console.log("UploadKit: Added `click` event listener", C);
                                } else y.addEventListener("click", m.openUploadDialog.bind(c)), m.debug && console.log("UploadKit: Added `click` event listener", y);
                                m.callbacks && m.callbacks.afterRender && m.callbacks.afterRender({ el: p, uploader: c });
                            }
                        }
                    }
            }),
            (m.runAfterUploadcareInitializedCallback = function () {
                m.afterUploadcareInitialized && m.afterUploadcareInitialized();
            }),
            (m.findForm = function (e) {
                var t = m.findAncestor(e, "form");
                return t || (e && e.dataset.formSelector && (t = a.querySelector(e.dataset.formSelector))), t;
            }),
            (m.findAncestor = function (e, a) {
                if ("function" == typeof e.closest) return e.closest(a) || null;
                for (; e; ) {
                    if (e.matches(a)) return e;
                    e = e.parentElement;
                }
                return null;
            }),
            (m.requiredValidation = function (e) {
                if ((m.debug && console.log("UploadKit.requiredValidation", this, e), vex)) {
                    var a = this,
                        t = m.containerInvalidUploaders(a);
                    t.length > 0 &&
                        (vex.dialog.alert({ unsafeMessage: t[0].requiredMessage, buttons: [{ text: t[0].requiredButtonText, type: "submit", className: "vex-dialog-button-primary uploadkit-ok-button" }], className: "vex-theme-plain" }),
                        e.preventDefault(),
                        e.stopImmediatePropagation());
                    var i = m.containerTextInvalidUploaders(a);
                    i.length > 0 &&
                        (vex.dialog.alert({
                            unsafeMessage: i[0].textRequiredMessage,
                            buttons: [{ text: i[0].textRequiredButtonText, type: "submit", className: "vex-dialog-button-primary uploadkit-ok-button" }],
                            className: "vex-theme-plain",
                        }),
                        e.preventDefault(),
                        e.stopImmediatePropagation());
                }
            }),
            (m.containerInvalidUploaders = function (e) {
                var a = [],
                    t = e.querySelectorAll(".uploadkit-uploader");
                if (!m.config.uploaders) return [];
                for (var i = 0; i < t.length; i++)
                    for (var l = 0; l < m.config.uploaders.length; l++)
                        if (m.config.uploaders[l].id === t[i].dataset.uploaderId && "true" === t[i].dataset.active && m.activeForCurrentLanguage(m.config.uploaders[l])) {
                            var o = m.config.uploaders[l],
                                n = o.files
                                    ? o.files.filter(function (e) {
                                          return !!e.fileInfo;
                                      })
                                    : [],
                                r = o.files
                                    ? o.files.filter(function (e) {
                                          return !e.fileInfo;
                                      })
                                    : [];
                            o.required && (n.length < (o.multipleMin && o.multipleMin > 1 ? o.multipleMin : 1) || (o.multipleMax && o.multipleMax > 0 && n.length > o.multipleMax) || r.length > 0) && a.push(o);
                        }
                return a;
            }),
            (m.containerTextInvalidUploaders = function (e) {
                var a = [],
                    t = e.querySelectorAll(".uploadkit-uploader");
                if (!m.config.uploaders) return [];
                for (var i = 0; i < t.length; i++)
                    for (var l = 0; l < m.config.uploaders.length; l++)
                        if (m.config.uploaders[l].id === t[i].dataset.uploaderId && "true" === t[i].dataset.active && m.activeForCurrentLanguage(m.config.uploaders[l])) {
                            var o = m.config.uploaders[l];
                            if (o.textRequired) {
                                for (var n = t[i].querySelectorAll(".uploadkit-textarea"), r = !1, s = 0; s < n.length; s++) 0 === n[s].value.replace(/\s/g, "").length && (r = !0);
                                r && a.push(o);
                            }
                        }
                return a;
            }),
            (m.activeForCurrentLanguage = function (e) {
                return m.multiLanguage ? m.currentLanguage === e.language : !0 !== m.useHtmlLanguage || !a.documentElement.lang || (m.getCurrentLanguage ? m.getCurrentLanguage() === e.language : a.documentElement.lang === e.language);
            }),
            (m.addFormRequiredValidation = function (e) {
                for (var a = 0; a < Math.min(e.length, 100); a++) {
                    var t = e[a];
                    m.refreshFormRequiredValidation(t);
                    var i = m.findForm(t);
                    if (i) {
                        i.dataset.uploadkitValidationAdded || i.addEventListener("submit", m.requiredValidation.bind(t));
                        var l = i.querySelectorAll(
                            "[type=submit],.btn-addtocart,.add_to_cart,.btn.add-to-cart,.btn--add-to-cart,.add-to-cart-btn,button[data-pf-type=ProductATC],.button--add-to-cart,.product-form__cart-submit,.rfq-btn,.gt_button[attribute=addToCart],.gt_button[attribute=buyItNow],.button--addToCart,.gt_product-button,button[data-pf-type=ProductATC],div.atc-cover,button[data-attribute=productButtonAddToCart],button[data-attribute=productButtonBuyNow],button[data-attribute=productButtonBuyItNow],.product-submit.action-button"
                        );
                        m.debug && console.log("UploadKit: form buttons", l);
                        for (var o = 0; o < Math.min(l.length, 100); o++) {
                            var n = l[o];
                            if (
                                !n.dataset.uploadkitValidationAdded &&
                                (n.addEventListener("click", m.requiredValidation.bind(t)), (n.dataset.uploadkitValidationAdded = !0), !0 === m.cloneATCButton && -1 === n.className.indexOf("uploadkit-original-atc-button"))
                            ) {
                                var r = n.cloneNode(!0);
                                (r.dataset.action = ""),
                                    (r.id = ""),
                                    r.setAttribute("type", "button"),
                                    r.setAttribute("name", ""),
                                    r.setAttribute("onclick", ""),
                                    (r.className = r.className.replace("product-form__cart-submit", "").replace("addtocart-js", "").replace("p_a_t_c", "")),
                                    (r.className = r.className + " uploadkit-cloned-atc-button"),
                                    (n.className = n.className + " uploadkit-original-atc-button"),
                                    r.addEventListener("click", m.requiredValidation.bind(t)),
                                    n.parentNode.insertBefore(r, n),
                                    setTimeout(function () {
                                        r.setAttribute("type", "button");
                                    }, 200);
                            }
                        }
                        i.dataset.uploadkitValidationAdded = !0;
                    }
                }
            }),
            (m.refreshFormRequiredValidation = function (e) {
                var a = m.findForm(e);
                a &&
                    (-1 === a.className.indexOf("uploadkit-form") && (a.className = a.className + " uploadkit-form"),
                    m.containerInvalidUploaders(e).length > 0
                        ? (-1 === a.className.indexOf("uploadkit-invalid") && (a.className = a.className + " uploadkit-invalid"), m.callbacks && m.callbacks.onFormInvalid && m.callbacks.onFormInvalid.call(this, a))
                        : ((a.className = a.className.replace("uploadkit-invalid", "")), m.callbacks && m.callbacks.onFormValid && m.callbacks.onFormValid.call(this, a)));
            }),
            (m.init = function () {
                (m.initialized = !0),
                    m.stylesheet || (m.stylesheet = m.setupStylesheet()),
                    m.previewMessageStylesheet || (m.previewMessageStylesheet = m.createStylesheet()),
                    (m.containers = m.findOrCreateContainers()),
                    (m.textFields = m.textFields || {}),
                    (m.activeUploaders = []),
                    m.config.uploaders && m.renderUploaders(m.containers, m.config.uploaders),
                    m.addFormRequiredValidation(m.containers),
                    m.containers.length > 0 && !m.dependenciesLoaded && m.loadDependencies();
            });
        var c = function (e) {
                return "fi" === e || "lt" === e || "id" === e || "hu" === e || "si" === e
                    ? function (e) {
                          return 1 === e ? "one" : "other";
                      }
                    : null;
            },
            f = function (e, a) {
                var t = {
                    en: {
                        errors: {
                            imagesOnly: "Only image files can be uploaded",
                            imageTooSmall: e.minimumImageSize ? "Your image must be at least " + e.minimumImageSize[0] + " pixels × " + e.minimumImageSize[1] + " pixels" : "Sorry, your image is too small",
                            fileTypes: e.fileTypes ? "Your file must be one of: " + e.fileTypes : "This file type is not supported",
                            filesize: e.maximumFileSize ? "The maximum file size is " + e.maximumFileSize + "MB" : "The size of that file is too large",
                        },
                        dialog: {
                            tabs: {
                                preview: {
                                    error: {
                                        imagesOnly: { title: "Oops!", text: "Only image files can be uploaded", back: "Please try a different file" },
                                        imageTooSmall: {
                                            title: "Oops!",
                                            text: e.minimumImageSize ? "Your image must be at least " + e.minimumImageSize[0] + " pixels × " + e.minimumImageSize[1] + " pixels" : "Sorry, your image is too small",
                                            back: "Please try uploading a larger image",
                                        },
                                        fileTypes: { title: "Oops!", text: e.fileTypes ? "Your file must be one of: " + e.fileTypes : "This file type is not supported", back: "Please try a different file" },
                                        filesize: { title: "Oops!", text: e.maximumFileSize ? "The maximum file size is " + e.maximumFileSize + "MB" : "The size of that file is too large", back: "Please try a different file" },
                                    },
                                },
                            },
                        },
                    },
                    nl: {
                        errors: {
                            imagesOnly: "Sorry, je kunt alleen afbeeldingen uploaden",
                            imageTooSmall: e.minimumImageSize ? "De afmetingen moeten minimaal " + e.minimumImageSize[0] + " pixels × " + e.minimumImageSize[1] + " pixels zijn" : "Sorry, de gekozen afbeelding is te klein",
                            fileTypes: e.fileTypes ? "De volgende bestandstypes kunnen gekozen worden: " + e.fileTypes : "Dit type bestand wordt niet ondersteund",
                            filesize: e.maximumFileSize ? "Het bestand kan maximaal " + e.maximumFileSize + "MB" : "Sorry, het gekozen bestand is te groot",
                        },
                        dialog: {
                            tabs: {
                                file: { also: "Of selecteer een bestand van" },
                                preview: {
                                    error: {
                                        imagesOnly: { title: "Oeps!", text: "Sorry, je kunt alleen afbeeldingen uploaden", back: "Probeer het nog eens met een andere bestand." },
                                        imageTooSmall: {
                                            title: "Oeps!",
                                            text: e.minimumImageSize ? "De afmetingen moeten minimaal " + e.minimumImageSize[0] + " pixels × " + e.minimumImageSize[1] + " pixels zijn" : "Sorry, de gekozen afbeelding is te klein",
                                            back: "Probeer het nog eens met een andere bestand.",
                                        },
                                        fileTypes: {
                                            title: "Oeps!",
                                            text: e.fileTypes ? "De volgende bestandstypes kunnen gekozen worden: " + e.fileTypes : "Dit type bestand wordt niet ondersteund",
                                            back: "Probeer het nog eens met een andere bestand.",
                                        },
                                        filesize: {
                                            title: "Oeps!",
                                            text: e.maximumFileSize ? "Het bestand kan maximaal " + e.maximumFileSize + "MB zijn" : "Sorry, het gekozen bestand is te groot",
                                            back: "Probeer het nog eens met een andere bestand.",
                                        },
                                    },
                                },
                            },
                        },
                    },
                    de: {
                        errors: {
                            imagesOnly: "Nur Bilder können hochgeladen werden",
                            imageTooSmall: e.minimumImageSize ? "Die Kürzeste Seite ihres Bildes muss " + e.minimumImageSize[0] + " Pixel × " + e.minimumImageSize[1] + " Pixel Groß sein." : "Dein Bild ist zu klein",
                            fileTypes: e.fileTypes ? "Ihre Datei muss Folgendes sein: " + e.fileTypes : "Dieser Dateityp wird nicht unterstützt",
                        },
                        dialog: {
                            tabs: {
                                preview: {
                                    multiple: { title: "Sie haben %files% gewählt", tooFewFiles: "Sie haben %files%. Es sind mindestens %min% nötig." },
                                    error: {
                                        imagesOnly: { title: "Hoopla !", text: "Nur Bilder können hochgeladen werden", back: "Bitte lade erneut ein anderes Bild hoch" },
                                        imageTooSmall: {
                                            title: "Hoopla !",
                                            text: e.minimumImageSize ? "Das Bild muss mindestens " + e.minimumImageSize[0] + " Pixel × " + e.minimumImageSize[1] + " Pixel Groß sein." : "Dein Bild ist zu klein",
                                            back: "Bitte lade erneut ein anderes Bild hoch",
                                        },
                                        fileTypes: { title: "Hoopla !", text: e.fileTypes ? "Ihre Datei muss Folgendes sein: " + e.fileTypes : "Dieser Dateityp wird nicht unterstützt", back: "Bitte laden Sie eine andere Datei hoch" },
                                    },
                                },
                            },
                        },
                    },
                    lt: {
                        uploading: "Įkeliama... Prašome palaukti.",
                        loadingInfo: "Kraunama...",
                        errors: {
                            default: "Klaida",
                            baddata: "Incorrect value",
                            size: "Failas yra per didelis",
                            upload: "Negalima įkelti",
                            user: "Įkėlimas atšauktas",
                            info: "Negalima užkrauti informacijos",
                            image: "Leidžiama įkelti tik paveikslėlį",
                            createGroup: "Negalima sukurti failų grupės",
                            deleted: "Failas buvo ištrintas",
                            imagesOnly: "Galima įkelti tik paveikslėlius",
                            imageTooSmall: e.minimumImageSize ? "Jūsų paveikslėlis privalo būti bent " + e.minimumImageSize[0] + " pixels × " + e.minimumImageSize[1] + " pixels" : "Jūsų paveikslėlis yra per mažas",
                            fileTypes: e.fileTypes ? "Jūsų failo tipas turi būti vienas iš: " + e.fileTypes : "Šis failo tipas nepalaikomas",
                        },
                        draghere: "Įkelkite failą čia",
                        file: { one: "%1 failas", other: "%1 failai" },
                        buttons: { cancel: "Atšaukti", remove: "Pašalinti", choose: { files: { one: "Pasirinkti failą", other: "Pasirinkti failus" }, images: { one: "Pasirinkti nuotrauką", other: "Pasirinkti nuotrauką" } } },
                        dialog: {
                            close: "Uždaryti",
                            openMenu: "Atidaryti meniu",
                            done: "Baigta",
                            showFiles: "Rodyti failus",
                            tabs: {
                                names: {
                                    "empty-pubkey": "Welcome",
                                    preview: "Peržiūrėti",
                                    file: "Lokalūs failai",
                                    url: "Direct Link",
                                    camera: "Camera",
                                    facebook: "Facebook",
                                    dropbox: "Dropbox",
                                    gdrive: "Google Drive",
                                    gphotos: "Google Photos",
                                    instagram: "Instagram",
                                    vk: "VK",
                                    evernote: "Evernote",
                                    box: "Box",
                                    onedrive: "OneDrive",
                                    flickr: "Flickr",
                                    huddle: "Huddle",
                                },
                                file: {
                                    drag: "Įkelkite<br>nuotrauką",
                                    nodrop: "Įkelti nuotrauką iš&nbsp;kompiuterio",
                                    cloudsTip: "Debesų saugyklos<br>ir socialiniai tinklai",
                                    or: "arba",
                                    button: "Pasirinkti nuotrauką",
                                    also: "arba pasirinkti iš",
                                },
                                url: { title: "Failai iš interneto", line1: "Pasirinkite bet kokį failą iš interneto.", line2: "Pateikite failo nuorodą.", input: "Įklijuokite nuorodą čia...", button: "Įkelti" },
                                camera: {
                                    title: "File from web camera",
                                    capture: "Take a photo",
                                    mirror: "Mirror",
                                    startRecord: "Record a video",
                                    stopRecord: "Stop",
                                    cancelRecord: "Cancel",
                                    retry: "Request permissions again",
                                    pleaseAllow: {
                                        title: "Please allow access to your camera",
                                        text: "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
                                    },
                                    notFound: { title: "No camera detected", text: "Looks like you have no camera connected to this device." },
                                },
                                preview: {
                                    unknownName: "unknown",
                                    change: "Atšaukti",
                                    back: "Atgal",
                                    done: "Įkelti",
                                    unknown: { title: "Įkeliama...Palaukite kol bus pateikta peržiūra", done: "Praleisti peržiūrą ir pateikti" },
                                    regular: { title: "Add this file?", line1: "You are about to add the file above.", line2: "Please confirm." },
                                    image: { title: "Pridėti šią nuotrauką?", change: "Atšaukti" },
                                    crop: { title: "Apkarpyti ir įkelti", done: "Baigta", free: "nemokama" },
                                    video: { title: "Add this video?", change: "Cancel" },
                                    error: {
                                        default: { title: "Ups!", text: "Įvyko klaida įkeliant failą.", back: "Bandykite dar kartą" },
                                        image: { title: "Galima įkelti tik paveikslėlius", text: "Prašome bandykite dar kartą su paveikslėliu", back: "Pasirinkti paveikslėlį" },
                                        size: { title: "Failas kurį pasirinkote viršija leistiną dydį.", text: "Prašome bandykite dar kartą su kitu paveikslėliu" },
                                        loadImage: { title: "Klaida", text: "Negalima įkelti nuotraukos" },
                                        imagesOnly: { title: "Ups!", text: "Galima įkelti tik paveikslėlius", back: "Įkelkite kitą failą" },
                                        imageTooSmall: {
                                            title: "Ups!",
                                            text: e.minimumImageSize ? "Jūsų paveikslėlis privalo būti bent " + e.minimumImageSize[0] + " pixels × " + e.minimumImageSize[1] + " pixels" : "Jūsų paveikslėlis yra per mažas",
                                            back: "Įkelkite didesnio dydžio failą",
                                        },
                                        fileTypes: { title: "Ups!", text: e.fileTypes ? "Jūsų failo tipas turi būti vienas iš: " + e.fileTypes : "Šis failo tipas nepalaikomas", back: "Įkelkite kitą failą" },
                                    },
                                    multiple: {
                                        title: "Jūs pasirinkote %files%.",
                                        question: "Pridėti %files%?",
                                        tooManyFiles: "Jūs pasirinkote per daug failų %max% yra maksimumas.",
                                        tooFewFiles: "You’ve chosen %files%. At least %min% required.",
                                        clear: "Pašalinti visus",
                                        done: "Pridėti",
                                        file: { preview: "Preview %file%", remove: "Remove %file%" },
                                    },
                                },
                            },
                        },
                        effects: {
                            captions: { blur: "Sulieti", crop: "Apkirpti", enhance: "Padidinti", flip: "Apversti", grayscale: "Pilkas filtras", invert: "Invert", mirror: "Veidrodis", rotate: "Pasukti", sharp: "Paryškinti" },
                            apply: "Taikyti",
                        },
                    },
                    zhTW: {
                        uploading: "上載中，請稍等。",
                        loadingInfo: "加載訊息中",
                        errors: {
                            imagesOnly: "只可上載圖檔",
                            imageTooSmall: e.minimumImageSize ? "您的圖檔必須是 " + e.minimumImageSize[0] + " pixels × " + e.minimumImageSize[1] + " pixels" : "對不起，您的圖檔太小了",
                            fileTypes: e.fileTypes ? "只支援圖檔格式包括 " + e.fileTypes : "不支援此圖檔格式",
                            default: "錯誤",
                            baddata: "數據錯誤",
                            size: "檔案太大",
                            upload: "不能上載",
                            user: "上載已取消",
                            info: "不能加載訊息",
                            image: "只可選取圖片檔案",
                            createGroup: "不能建立檔案群",
                            deleted: "檔案已刪除",
                        },
                        draghere: "把檔案拉到此處",
                        file: { other: "%1 個檔案" },
                        buttons: { cancel: "取消", remove: "移除", choose: { files: { one: "選擇1個檔案", other: "選擇多個檔案" }, images: { one: "選擇1個圖案", other: "選擇多個圖案" } } },
                        dialog: {
                            close: "關閉",
                            openMenu: "開啟選單",
                            done: "完成",
                            showFiles: "顯示檔案",
                            tabs: {
                                names: {
                                    "empty-pubkey": "歡迎",
                                    preview: "預覽",
                                    file: "Local File",
                                    url: "Direct Link",
                                    camera: "Camera",
                                    facebook: "Facebook",
                                    dropbox: "Dropbox",
                                    gdrive: "Google Drive",
                                    gphotos: "Google Photos",
                                    instagram: "Instagram",
                                    vk: "VK",
                                    evernote: "Evernote",
                                    box: "Box",
                                    onedrive: "OneDrive",
                                    flickr: "Flickr",
                                    huddle: "Huddle",
                                },
                                file: { drag: "把檔案<br>拉到此處", nodrop: "從電腦中上載照片", cloudsTip: "雲端及<br>社交網絡", or: "或", button: "選取檔案", also: "或從以下途徑選取" },
                                url: { title: "網絡檔案", line1: "從網絡中取得檔案", line2: "請提供連結", input: "請在此處貼上連結", button: "上載" },
                                camera: {
                                    title: "網絡相機照相",
                                    capture: "拍照",
                                    mirror: "左右相調",
                                    startRecord: "錄製錄影",
                                    stopRecord: "停止",
                                    cancelRecord: "取消",
                                    retry: "再次請求權限",
                                    pleaseAllow: { title: "請容許我們讀取您的相機", text: "請同意我們讀取您的相機<br>您需要同意此項要求才能夠拍照" },
                                    notFound: { title: "偵測不到相機", text: "您的裝置並沒有連接相機" },
                                },
                                preview: {
                                    unknownName: "不明",
                                    change: "取消",
                                    back: "返回",
                                    done: "加入",
                                    unknown: { title: "上載中... 請耐心等待預覽", done: "跳過預覽並確認" },
                                    regular: { title: "加入此檔案？", line1: "檔案快將上載完畢", line2: "請確認" },
                                    image: { title: "加入此圖檔？", change: "取消" },
                                    crop: { title: "剪裁並加入此圖檔", done: "完成", free: "free" },
                                    video: { title: "加入此錄影？", change: "取消" },
                                    error: {
                                        default: { title: "噢！", text: "我們在上載時遇到少許問題", back: "請重試" },
                                        image: { title: "只接受圖檔", text: "請選取其他檔案再重試", back: "選取圖檔" },
                                        size: { title: "您選取的檔案數目超過上限", text: "請選取其他檔案再重試" },
                                        loadImage: { title: "錯誤", text: "不能加載圖檔" },
                                        imagesOnly: { title: "噢！", text: "只可上載圖檔", back: "請選取圖檔再重試" },
                                        imageTooSmall: {
                                            title: "噢！",
                                            text: e.minimumImageSize ? "您的圖檔必須是 " + e.minimumImageSize[0] + " pixels × " + e.minimumImageSize[1] + " pixels" : "對不起，您的圖檔太小了",
                                            back: "請選取大一點的圖檔再重新上載",
                                        },
                                        fileTypes: { title: "噢！", text: e.fileTypes ? "只支援圖檔格式包括 " + e.fileTypes : "不支援此圖檔格式", back: "請選取圖檔再重試" },
                                    },
                                    multiple: {
                                        title: "您已選取 %files%.",
                                        question: "加入 %files%？",
                                        tooManyFiles: "您選取的檔案過多，最多可選取 %max% 項",
                                        tooFewFiles: "您已選取 %files%，最少選取 %min% 項",
                                        clear: "移除所有",
                                        done: "加入",
                                        file: { preview: "預覽 %file%", remove: "移除 %file%" },
                                    },
                                },
                            },
                        },
                    },
                    fi: {
                        uploading: "Ladataan... Odota hetki",
                        loadingInfo: "Ladataan tietoja...",
                        draghere: "Tiputa tiedosto tähän",
                        file: { one: "%1 tiedosto", other: "%1 tiedostot" },
                        buttons: { cancel: "Peruuta", remove: "Poista", choose: { files: { one: "Valitse tiedost", other: "Valitse tiedostot" }, images: { one: "Valitse kuva", other: "Valitse kuvat" } } },
                        dialog: {
                            close: "Sulje",
                            openMenu: "Avaa valikko",
                            done: "Valmis",
                            showFiles: "Näytä tiedostot",
                            tabs: {
                                names: {
                                    "empty-pubkey": "Tervetuloa",
                                    preview: "Esikatsele",
                                    file: "Paikalliset tiedostot",
                                    url: "Linkki",
                                    camera: "Kamera",
                                    facebook: "Facebook",
                                    dropbox: "Dropbox",
                                    gdrive: "Google Drive",
                                    gphotos: "Google Photos",
                                    instagram: "Instagram",
                                    vk: "VK",
                                    evernote: "Evernote",
                                    box: "Box",
                                    onedrive: "OneDrive",
                                    flickr: "Flickr",
                                    huddle: "Huddle",
                                },
                                file: {
                                    drag: "raahaa ja pudota<br>tiedostoja",
                                    nodrop: "Lataa tiedostoja&nbsp;tietokoneelta",
                                    cloudsTip: "Pilvipalvelut<br>ja sosiaaliset mediat",
                                    or: "tai",
                                    button: "Valitse paikallinen tiedosto",
                                    also: "valitse seuraavista",
                                },
                                url: { title: "Tiedostot verkosta", line1: "Valitse tiedosto verkosta", line2: "Sinun tarvitsee antaa vain linkki.", input: "Liitä linkkisi tähän...", button: "Lataa" },
                                camera: {
                                    title: "Kuva web-kamerasta",
                                    capture: "Ota kuva",
                                    mirror: "Peilaus",
                                    startRecord: "Nauhoita video",
                                    stopRecord: "Seis",
                                    cancelRecord: "Peruuta",
                                    retry: "Valtuuta uudelleen",
                                    pleaseAllow: { title: "Anna lupa kamerallesi", text: "Tämä sivusto kehoittaa antamaan luvan käyttää kameraasi<br>Ottaaksesi kuvan kamerallasi sinun tulee antaa verkkosivulle lupa." },
                                    notFound: { title: "Ei löydetty kameraa", text: "Näyttää siltä että laitteeseesi ei ole kytketty kameraa." },
                                },
                                preview: {
                                    unknownName: "tuntematon",
                                    change: "Peruuta",
                                    back: "Takaisin",
                                    done: "Lisää",
                                    unknown: { title: "Ladataan... Odota hetki esikatselua varten.", done: "Ohita esikatselu ja hyväksy" },
                                    regular: { title: "Lisää tämä tiedosto?", line1: "Olet lisäämässä ylläolevan tiedoston,", line2: "Ole hyvä ja varmista." },
                                    image: { title: "Lisää tämä kuva?", change: "Peruuta" },
                                    crop: { title: "Rajaa ja lisää tämä kuva", done: "Valmis", free: "vapaa" },
                                    video: { title: "Lisää tämä video?", change: "Peruuta" },
                                    error: {
                                        default: { title: "Hups!", text: "Jotain meni vikaan ladatessa tiedostoa.", back: "Ole hyvä ja yritä uudestaan" },
                                        image: { title: "Vain kuvatiedostot ovat sallittuja.", text: "Ole hyvä ja yritä uudelleen toisella tiedostolla.", back: "Valitse kuva" },
                                        size: { title: "Valitsemasi tiedosto on liian suuri.", text: "Ole hyvä ja yritä uudelleen toisella tiedostolla." },
                                        loadImage: { title: "Virhe", text: "Kuvan lataus epäonnistui" },
                                        imagesOnly: { title: "Hups!", text: "Vain kuvatiedostoja voidaan ladata", back: "Ole hyvä ja yritä uudelleen toisella tiedostolla" },
                                        imageTooSmall: {
                                            title: "Hups!",
                                            text: e.minimumImageSize ? "Kuvakoon tulee olla vähintään " + e.minimumImageSize[0] + " pikseliä Ũ " + e.minimumImageSize[1] + " pikseliä" : "Kuvasi on liian pieni",
                                            back: "Ole hyvä ja yritä uudelleen suuremmalla tiedostolla",
                                        },
                                        fileTypes: {
                                            title: "Hups!",
                                            text: e.fileTypes ? "Tiedostotyypin tulee olla joku seuraavista: " + e.fileTypes : "Tämä tiedostotyyppi ei ole tuettu",
                                            back: "Ole hyvä ja yritä uudelleen toisella tiedostolla",
                                        },
                                    },
                                    multiple: {
                                        title: "Olet valinnut %files%",
                                        question: "Lisätäänkö %files%?",
                                        tooManyFiles: "Olet valinnut liian monta tiedostoa. %max% on enimmäismäärä.",
                                        tooFewFiles: "olet valinnut %files%. Vähintään %min% vaaditaan.",
                                        clear: "Poista kaikki",
                                        done: "Lisää",
                                        file: { preview: "Esikatsele %file%", remove: "Poista %file%" },
                                    },
                                },
                            },
                        },
                        effects: { captions: { blur: "Sumenna", crop: "Rajaa", enhance: "Korosta", flip: "Pyöritä", grayscale: "Harmaasävy", invert: "Invertoi", mirror: "Peilaus", rotate: "Käännä", sharp: "Terävöitä" }, apply: "Tallenna" },
                        errors: {
                            default: "Virhe",
                            baddata: "Väärä arvo",
                            size: "Liian suuri tiedosto",
                            upload: "Ei voitu ladata",
                            user: "Lataus peruttu",
                            info: "Ei voitu ladata tietoja",
                            image: "Vain kuvien lataus sallittu",
                            createGroup: "Tiedostoryhmän luonti epäonnistui",
                            deleted: "Tiedosto poistettu",
                            imagesOnly: "Vain kuvatiedostoja voidaan ladata",
                            imageTooSmall: e.minimumImageSize ? "Kuvakoon tulee olla vähintään " + e.minimumImageSize[0] + " pikseliä Ũ " + e.minimumImageSize[1] + " pikseliä" : "Kuvasi on liian pieni",
                            fileTypes: e.fileTypes ? "Tiedostotyypin tulee olla joku seuraavista: " + e.fileTypes : "Tämä tiedostotyyppi ei ole tuettu",
                        },
                    },
                    id: {
                        uploading: "Sedang diunggah... Mohon tunggu.",
                        loadingInfo: "Sedang memuat info...",
                        draghere: "Letakkan file di sini",
                        file: { one: "%1 file", other: "%1 file" },
                        buttons: { cancel: "Batal", remove: "Hapus", choose: { files: { one: "Pilih file", other: "Pilih file" }, images: { one: "Pilih gambar", other: "Pilih gambar" } } },
                        dialog: {
                            close: "Tutup",
                            openMenu: "Buka menu",
                            done: "Selesai",
                            showFiles: "Tampilkan file",
                            tabs: {
                                names: {
                                    "empty-pubkey": "Selamat datang",
                                    preview: "Pratinjau",
                                    file: "File Lokal",
                                    url: "Link Langsung",
                                    camera: "Kamera",
                                    facebook: "Facebook",
                                    dropbox: "Dropbox",
                                    gdrive: "Google Drive",
                                    gphotos: "Google Photos",
                                    instagram: "Instagram",
                                    vk: "VK",
                                    evernote: "Evernote",
                                    box: "Box",
                                    onedrive: "OneDrive",
                                    flickr: "Flickr",
                                    huddle: "Huddle",
                                },
                                file: {
                                    drag: "seret dan letakan<br>file",
                                    nodrop: "Unggah file dari&nbsp;komputer Anda",
                                    cloudsTip: "Penyimpanan cloud<br>dan social networks",
                                    or: "atau",
                                    button: "Pilih file lokal",
                                    also: "atau pilih dari",
                                },
                                url: { title: "File dari Web", line1: "Ambil file apa pun dari web", line2: "Cukup berikan link.", input: "Paste link anda disini...", button: "Unggah" },
                                camera: {
                                    title: "File dari kamera",
                                    capture: "Ambil foto",
                                    mirror: "Cermin",
                                    startRecord: "Rekam video",
                                    stopRecord: "Stop",
                                    cancelRecord: "Batal",
                                    retry: "Minta izin lagi",
                                    pleaseAllow: {
                                        title: "Mohon izinkan akses ke kamera Anda",
                                        text: "Anda telah diminta untuk mengizinkan akses kamera dari situs ini.<br>Untuk mengambil gambar dengan kamera Anda, Anda harus menyetujui permintaan ini.",
                                    },
                                    notFound: { title: "Tidak ada kamera yang terdeteksi", text: "Sepertinya Anda tidak memiliki kamera yang terhubung ke perangkat ini." },
                                },
                                preview: {
                                    unknownName: "tidak diketahui",
                                    change: "Batal",
                                    back: "Kembali",
                                    done: "Selesai",
                                    unknown: { title: "Sedang diunggah... Harap tunggu pratinjau.", done: "Lewati pratinjau dan lanjutkan" },
                                    regular: { title: "Unggah file ini?", line1: "Anda akan mengunggah file di atas.", line2: "Mohon konfirmasi." },
                                    image: { title: "Unggah foto ini?", change: "Batal" },
                                    crop: { title: "Potong dan unggah gambar ini", done: "Selesai", free: "bebas" },
                                    video: { title: "Unggah video ini?", change: "Batal" },
                                    error: {
                                        default: { title: "Oops!", text: "Terjadi kesalahan saat mengunggah.", back: "Silakan coba lagi" },
                                        image: { title: "Hanya file gambar yang diterima", text: "Silakan coba lagi dengan file lain.", back: "Pilih gambar" },
                                        size: { title: "File yang Anda pilih melebihi batas.", text: "Silakan coba lagi dengan file lain." },
                                        loadImage: { title: "Error", text: "Tidak dapat memuat gambar" },
                                        imagesOnly: { title: "Oops!", text: "Hanya file gambar yang dapat diunggah", back: "Silakan coba file lain" },
                                        imageTooSmall: {
                                            title: "Oops!",
                                            text: e.minimumImageSize ? "Setidaknya gambar Anda memiliki " + e.minimumImageSize[0] + " pixels × " + e.minimumImageSize[1] + " pixels" : "Maaf, gambar Anda terlalu kecil",
                                            back: "Silakan coba unggah gambar yang lebih besar",
                                        },
                                        fileTypes: { title: "Oops!", text: e.fileTypes ? "File Anda harus salah satu dari: " + e.fileTypes : "Jenis file ini tidak didukung", back: "Silakan coba file lain" },
                                    },
                                    multiple: {
                                        title: "Anda sudah memilih %files%.",
                                        question: "Unggah %files%?",
                                        tooManyFiles: "Anda telah memilih terlalu banyak file. Maximum %max% file.",
                                        tooFewFiles: "Anda sudah memilih %files% file. Setidaknya dibutuhkan %min% file.",
                                        clear: "Hapus semua",
                                        done: "Selesai",
                                        file: { preview: "Pratinjau %file%", remove: "Hapus %file%" },
                                    },
                                },
                            },
                        },
                        effects: { captions: { blur: "Blur", crop: "Memotong", enhance: "Memperbaiki", flip: "Balik", grayscale: "Abu-abu", invert: "Invert", mirror: "Cermin", rotate: "Putar", sharp: "Mempertajam" }, apply: "Terapkan" },
                        errors: {
                            default: "Error",
                            baddata: "Nilai salah",
                            size: "File terlalu besar",
                            upload: "Tidak dapat diunggah",
                            user: "Unggah batal",
                            info: "Tidak dapat memuat info",
                            image: "Hanya gambar yang diizinkan",
                            createGroup: "Tidak dapat membuat grup file",
                            deleted: "File dihapus",
                            imagesOnly: "Hanya file gambar yang dapat diunggah",
                            imageTooSmall: e.minimumImageSize ? "Setidaknya gambar Anda memiliki " + e.minimumImageSize[0] + " pixels × " + e.minimumImageSize[1] + " pixels" : "Maaf, gambar Anda terlalu kecil",
                            fileTypes: e.fileTypes ? "File Anda harus salah satu dari: " + e.fileTypes : "Jenis file ini tidak didukung",
                        },
                    },
                    hu: {
                        uploading: "Feltöltés... Kérlek Várj.",
                        loadingInfo: "Információ betöltés...",
                        errors: {
                            default: "Hiba",
                            baddata: "Helytelen érték",
                            size: "A fájl túl nagy",
                            upload: "Nem lehet feltölteni",
                            user: "Feltöltés törlés",
                            info: "Nem tölt be az információ",
                            image: "Csak képet tölthetsz fel",
                            createGroup: "Nem lehet fájlcsoportot létrehozni",
                            deleted: "File was deleted",
                            imagesOnly: "Csak képfájlokat lehet feltölteni",
                            imageTooSmall: e.minimumImageSize ? "Legalább ekkora képnek kell lennie " + e.minimumImageSize[0] + " pixels × " + e.minimumImageSize[1] + " pixels" : "Sajnos túl kicsi a kép",
                            fileTypes: e.fileTypes ? "A fájlnak meg kell lennie " + e.fileTypes : "Ez a fájltípus nem támogatott",
                        },
                        draghere: "Ide töltsd fel a fájlt",
                        file: { one: "%1 fájlt", other: "%1 fájlt" },
                        buttons: { cancel: "Törlés", remove: "Eltávoltít", choose: { files: { one: "Válasz egy fájlt", other: "Válasz egy fájlt" }, images: { one: "Válasz egy képet", other: "Válasz egy képet" } } },
                        dialog: {
                            close: "Bezárás",
                            openMenu: "Menü kinyitás",
                            done: "Kész van",
                            showFiles: "Mutasd a fájlt",
                            tabs: {
                                names: {
                                    "empty-pubkey": "Üdv",
                                    preview: "Megmutat",
                                    file: "Helyi Fájlt",
                                    url: "Direkt Link",
                                    camera: "Kamera",
                                    facebook: "Facebook",
                                    dropbox: "Dropbox",
                                    gdrive: "Google Drive",
                                    gphotos: "Google fotók",
                                    instagram: "Instagram",
                                    vk: "VK",
                                    evernote: "Evernote",
                                    box: "Box",
                                    onedrive: "OneDrive",
                                    flickr: "Flickr",
                                    huddle: "Huddle",
                                },
                                file: {
                                    drag: "Válasz ki<br>bármilyen fájlt",
                                    nodrop: "Tölts fel egy fájlt a &nbsp;gépedről",
                                    cloudsTip: "Cloud meghajtó<br>vagy sociális média",
                                    or: "vagy",
                                    button: "Válassz helyi fájlt",
                                    also: "Válassz másikat",
                                },
                                url: { title: "Fájlok az internetről", line1: "Fogjon meg minden fájlt az internetről.", line2: "Adj meg egy linket", input: "Illeszd be a linket...", button: "Feltölt" },
                                camera: {
                                    title: "Kép készítés kamerával",
                                    capture: "Csinálj képet",
                                    mirror: "Tükör",
                                    startRecord: "Rögzíts videót",
                                    stopRecord: "Stop",
                                    cancelRecord: "Törlés",
                                    retry: "Próbáld újra",
                                    pleaseAllow: {
                                        title: "Kérjük, engedélyezze a kamerához való hozzáférést",
                                        text: "A rendszer arra kéri, hogy engedje meg a kamera hozzáférését erről a webhelyről.<br>A fényképezőgéppel történő fényképezéshez jóvá kell hagyni ezt a kérést.",
                                    },
                                    notFound: { title: "Nem találok kamerát", text: "Úgy tűnik, hogy nincs kamerája csatlakoztatva ehhez az eszközhöz." },
                                },
                                preview: {
                                    unknownName: "Ismeretlen",
                                    change: "Törlés",
                                    back: "Vissza",
                                    done: "Hozzáad",
                                    unknown: { title: "Feltöltés... PKérlek várj a megjelenéshez.", done: "Tovább" },
                                    regular: { title: "Add hozzá ezt fájlt?", line1: "Arra készül, hogy hozzáadja a fenti fájlt.", line2: "Jóváhagy" },
                                    image: { title: "Add hozzá ezt képet?", change: "Törlés" },
                                    crop: { title: "Körbevágom a képet?", done: "Kész", free: "Szabad" },
                                    video: { title: "Hozzáadom ezt a videót?", change: "Törlés" },
                                    error: {
                                        default: { title: "Oops!", text: "A feltöltés során valami baj történt.", back: "Próbáld újra" },
                                        image: { title: "Csak a képfájlokat fogadjuk el.", text: "Próbálkozzon újra egy másik fájllal.", back: "Használk képet" },
                                        size: { title: "A kiválasztott fájl meghaladja a korlátot.", text: "Próbálkozzon újra egy másik fájllal." },
                                        loadImage: { title: "Hiba", text: "Nem töltött fel a kép" },
                                        imagesOnly: { title: "Oops!", text: "Csak képfájlokat lehet feltölteni", back: "Próbáljon meg egy másik fájlt" },
                                        imageTooSmall: { title: "Oops!", text: "", back: "Próbálj meg nagyobb képet feltölteni" },
                                        fileTypes: { title: "Oops!", text: "", back: "Kérjük, próbálj meg egy másik fájlt" },
                                    },
                                    multiple: {
                                        title: "Te választottad %files%.",
                                        question: "Hozzáad %files%?",
                                        tooManyFiles: "Túl sok fájlt választottál %max% maximum.",
                                        tooFewFiles: "Te választott %files%. At least %min% kötelező",
                                        clear: "Törlés mind",
                                        done: "Hozzáad",
                                        file: { preview: "Megtekint %file%", remove: "Töröl %file%" },
                                    },
                                },
                            },
                        },
                        effects: {
                            captions: { blur: "Elhomályosít", crop: "Körbevág", enhance: "Növel", flip: "Flip", grayscale: "Szürkeárnyalat", invert: "Megfordít", mirror: "Tükröz", rotate: "Forgat", sharp: "Élesít" },
                            apply: "Alkalmaz",
                        },
                    },
                    si: {
                        uploading: "Nalaganje...Prosim počakajte.",
                        loadingInfo: "Informacije o nalaganju",
                        errors: {
                            default: "Napaka",
                            baddata: "Napačna vrednost",
                            size: "Datoteka je prevelika",
                            upload: "Ni možno naložiti",
                            user: "Nalaganje preklicano",
                            info: "Ni možno naložiti informacije",
                            image: "Dovoljene so samo slike",
                            createGroup: "Ni možno narediti skupine slik",
                            deleted: "Datoteka je bila izbrisana",
                            imagesOnly: "Naložijo se lahko samo datoteke slik",
                            imageTooSmall: e.minimumImageSize ? "Vaša slika mora biti vsaj " + e.minimumImageSize[0] + " pikslov × " + e.minimumImageSize[1] + " pikslov" : "Vaša slika je žal premajhna",
                            fileTypes: e.fileTypes ? "Vaša slika more biti ena izmed: " + e.fileTypes : "Datoteka ni podprta",
                        },
                        draghere: "Spusti datoteko sem",
                        file: { one: "%1 datoteke", other: "%1 datoteke" },
                        buttons: { cancel: "Prekliči", remove: "Odstrani", choose: { files: { one: "Izberi datoteko", other: "Izberi datoteke" }, images: { one: "Izberi sliko", other: "Izberi sliko" } } },
                        dialog: {
                            close: "Zapri",
                            openMenu: "Odpri meni",
                            done: "Konec",
                            showFiles: "Prikaži datoteko",
                            tabs: {
                                names: {
                                    "empty-pubkey": "Dobrodošli",
                                    preview: "Predogled",
                                    file: "Lokalne datoteke",
                                    url: "Direktni link",
                                    camera: "Kamera",
                                    facebook: "Facebook",
                                    dropbox: "Dropbox",
                                    gdrive: "Google Drive",
                                    gphotos: "Google slike",
                                    instagram: "Instagram",
                                    vk: "VK",
                                    evernote: "Evernote",
                                    box: "Box",
                                    onedrive: "OneDrive",
                                    flickr: "Flickr",
                                    huddle: "Huddle",
                                },
                                file: {
                                    drag: "Potegni in spusti <br> datoteko",
                                    nodrop: "Naloži datoteko iz &nbsp;Računalnika",
                                    cloudsTip: "Shranjeno na oblaku <br>in socialnih omrežjih",
                                    or: "ali",
                                    button: "Izberi datoteko iz računalnika",
                                    also: "ali izberi iz",
                                },
                                url: { title: "Slike iz spleta", line1: "Zgrabi katerokoli datoteko iz spleta", line2: "Samo vpišite povezavo", input: "Pripnite link tukaj", button: "Naložite" },
                                camera: {
                                    title: "Datoteka iz spletne kamere",
                                    capture: "Slikaj s kamero",
                                    mirror: "Zrcali",
                                    startRecord: "Posnami video",
                                    stopRecord: "Stop",
                                    cancelRecord: "Prekliči",
                                    retry: "Še enkrat zaprosi za dovoljenje",
                                    pleaseAllow: { title: "Prosim dovolite dostop do vaše kamere", text: "Dobili ste prošnjo da uporabljate kamero na tej strani.<br>V kolikor želite slikati s to kamero morate dovoliti uporabo" },
                                    notFound: { title: "Kamera ni zaznana", text: "Izgleda da na napravo ni povezana nobena kamera" },
                                },
                                preview: {
                                    unknownName: "Neznano",
                                    change: "Prekliči",
                                    back: "Nazaj",
                                    done: "Dodaj",
                                    unknown: { title: "Nalaganje... Prosim počakajte predogled.", done: "Preskoči predogled in potrdi" },
                                    regular: { title: "Dodaj to datoteko?", line1: "Dodali boste datoteko prikazano zgoraj", line2: "Prosim potrdite" },
                                    image: { title: "Dodaj to sliko?", change: "Prekliči" },
                                    crop: { title: "Izreži in dodaj to sliko", done: "Končano", free: "Brezplačno" },
                                    video: { title: "Dodaj ta video?", change: "Prekliči" },
                                    error: {
                                        default: { title: "Ups!", text: "Med nalaganjem se je nekaj zalomilo!", back: "Prosim poizkusite kasneje" },
                                        image: { title: "Dovoljene so samo datoteke slik.", text: "Prosim preizkusite z drugo fotografijo.", back: "Izberi sliko." },
                                        size: { title: "Datoteka ki ste jo izbrali je prevelika", text: "Prosim poizkusite z drugo datoteko." },
                                        loadImage: { title: "Napaka", text: "Slike ni možno naložiti" },
                                        imagesOnly: { title: "Ups!", text: "Dovoljene so samo datoteke slik", back: "Poizkusite drugo datoteko" },
                                        imageTooSmall: { title: "Ups!", text: "", back: "Prosim poizkusite drugo datoteko" },
                                        fileTypes: { title: "Oops!", text: "", back: "Prosim poizkusite drugo datoteko" },
                                    },
                                    multiple: {
                                        title: "Izbrali ste %files%.",
                                        question: "Dodaj %files%?",
                                        tooManyFiles: "Izbrali ste preveč datotek. %max% is maximum.",
                                        tooFewFiles: "Izbrali ste toliko datotek: %files%. Zahtevanih je vsaj %min% datotek.",
                                        clear: "Odstrani vse",
                                        done: "Dodaj",
                                        file: { preview: "Predogled %file%", remove: "Odstrani %file%" },
                                    },
                                },
                            },
                        },
                        effects: { captions: { blur: "Zameglitev", crop: "Izreži", enhance: "Ojačaj.", flip: "Zasukaj", grayscale: "Črnobelo", invert: "Inverzno", mirror: "Zrcali", rotate: "Zavrti", sharp: "Izostritev" }, apply: "Potrdi" },
                    },
                    fr: {
                        errors: {
                            imagesOnly: "Seuls les fichiers image peuvent être téléchargés",
                            imageTooSmall: e.minimumImageSize ? "Votre image doit être au moins " + e.minimumImageSize[0] + " pixels × " + e.minimumImageSize[1] + " pixels" : "Votre image est trop petite",
                            fileTypes: e.fileTypes ? "Votre fichier doit être: " + e.fileTypes : "Ce type de fichier n'est pas supporté",
                        },
                        dialog: {
                            tabs: {
                                preview: {
                                    multiple: { tooFewFiles: "Vous avez choisi %files%. %min% est le minimum." },
                                    error: {
                                        imagesOnly: { title: "Désolé !", text: "Seuls les fichiers image peuvent être téléchargés", back: "Réessayer avec un autre fichier" },
                                        imageTooSmall: {
                                            title: "Désolé !",
                                            text: e.minimumImageSize ? "Votre image doit être au moins " + e.minimumImageSize[0] + " pixels × " + e.minimumImageSize[1] + " pixels" : "Votre image est trop petite",
                                            back: "Réessayer avec une image plus grande",
                                        },
                                        fileTypes: { title: "Désolé !", text: e.fileTypes ? "Votre fichier doit être: " + e.fileTypes : "Ce type de fichier n'est pas supporté", back: "Réessayer avec un autre fichier" },
                                    },
                                },
                            },
                        },
                    },
                };
                return t[a] || t.en;
            };
        (m.loadDependencies = function () {
            if (m.config.assetsBaseUri) {
                var e = a.createElement("link");
                (e.type = "text/css"), (e.rel = "stylesheet"), (e.href = m.config.assetsBaseUri + "/assets/vex.css"), a.head.appendChild(e);
                var t = a.createElement("script");
                (t.type = "text/javascript"), (t.async = !0), (t.src = m.config.assetsBaseUri + "/assets/vex.js"), a.head.appendChild(t), (m.dependenciesLoaded = !0);
            }
        }),
            (m.mimeTypes = {
                "application/atom+xml": "rss",
                "application/directx": "x",
                "application/java-archive": "jar",
                "application/msaccess": "accdb",
                "application/msword": "doc",
                "application/octet-stream": "bin",
                "application/oleobject": "ods",
                "application/pdf": "pdf",
                "application/postscript": "ai",
                "application/rtf": "rtf",
                "application/vnd.ms-excel.sheet.macroEnabled.12": "xlsm",
                "application/vnd.ms-excel.template.macroEnabled.12": "xltm",
                "application/vnd.ms-excel": "xls",
                "application/vnd.ms-pki.pko": "pko",
                "application/vnd.ms-pki.stl": "stl",
                "application/vnd.ms-powerpoint.presentation.macroEnabled.12": "pptm",
                "application/vnd.ms-powerpoint.slide.macroEnabled.12": "sldm",
                "application/vnd.ms-powerpoint": "ppt",
                "application/vnd.ms-project": "mpp",
                "application/vnd.ms-visio.viewer": "vdx",
                "application/vnd.ms-word.document.macroEnabled.12": "docm",
                "application/vnd.ms-word.template.macroEnabled.12": "dotm",
                "application/vnd.ms-works": "wps",
                "application/vnd.ms-xpsdocument": "xps",
                "application/vnd.openxmlformats-officedocument.presentationml.presentation": "pptx",
                "application/vnd.openxmlformats-officedocument.presentationml.slide": "sldx",
                "application/vnd.openxmlformats-officedocument.presentationml.slideshow": "ppsx",
                "application/vnd.openxmlformats-officedocument.presentationml.template": "potx",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.template": "xltx",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.template": "dotx",
                "application/vnd.rn-realmedia": "rm",
                "application/vnd.visio": "vsd",
                "application/x-compress": "z",
                "application/x-compressed": "tgz",
                "application/x-csh": "csh",
                "application/x-gzip": "gz",
                "application/x-java-applet": "class",
                "application/x-javascript": "js",
                "application/x-ms-reader": "lit",
                "application/x-msaccess": "mdb",
                "application/x-msdownload": "dll",
                "application/x-msmetafile": "wmf",
                "application/x-mspublisher": "pub",
                "application/x-mswrite": "wri",
                "application/x-pkcs12": "p12",
                "application/x-pkcs12": "pfx",
                "application/x-pkcs7-certificates": "p7b",
                "application/x-sh": "sh",
                "application/x-shockwave-flash": "swf",
                "application/x-tar": "tar",
                "application/x-tex": "tex",
                "application/x-troff-me": "me",
                "application/x-x509-ca-cert": "crt",
                "application/x-zip-compressed": "zip",
                "audio/aiff": "aiff",
                "audio/basic": "au",
                "audio/mid": "midi",
                "audio/wav": "wav",
                "audio/x-aiff": "aif",
                "audio/x-mpegurl": "m3u",
                "audio/x-ms-wax": "wax",
                "audio/x-ms-wma": "wma",
                "audio/x-pn-realaudio-plugin": "rpm",
                "audio/x-pn-realaudio": "ra",
                "image/bmp": "bmp",
                "image/gif": "gif",
                "image/jpeg": "jpeg",
                "image/png": "png",
                "image/svg+xml": "svg",
                "image/tiff": "tiff",
                "image/x-icon": "ico",
                "text/css": "css",
                "text/html": "html",
                "text/jscript": "jsx",
                "text/plain": "txt",
                "text/tab-separated-values": "tsv",
                "text/vbscript": "vbs",
                "text/xml": "xml",
                "video/mpeg": "mpeg",
                "video/quicktime": "mov",
                "video/x-flv": "flv",
                "video/x-ms-asf": "asx",
                "video/x-ms-wmv": "wmv",
                "video/x-msvideo": "avi",
            }),
            (m.runDOMContentLoaded = function () {
                if ("undefined" == typeof jQuery) {
                    var t = a.createElement("script");
                    (t.type = "text/javascript"), (t.async = !1), (t.src = "https://code.jquery.com/jquery-3.2.1.min.js"), a.head.appendChild(t);
                }
                if ("undefined" == typeof uploadcare) {
                    var i = a.createElement("script");
                    if (((i.type = "text/javascript"), (i.async = !1), (i.onload = m.runAfterUploadcareInitializedCallback), m.uploadcareURL)) i.src = m.uploadcareURL;
                    else if (m.uploadcareVersion)
                        m.forceJQuery
                            ? (i.src = "https://ucarecdn.com/libs/widget/" + m.uploadcareVersion + "/uploadcare.full" + (!1 === m.uploadcareMinify ? "" : ".min") + ".js")
                            : (i.src = "https://ucarecdn.com/libs/widget/" + m.uploadcareVersion + "/uploadcare" + (!1 === m.uploadcareMinify ? "" : ".min") + ".js");
                    else if (m.config && (!1 === m.config.whiteLabel || m.config.useLatestVersion)) {
                        var l = "3.17.2";
                        i.src = "https://assets.getuploadkit.com/assets/uploadcare-uploadkit-v" + l + (m.forceJQuery ? ".full" : "") + (!1 === m.uploadcareMinify ? "" : ".min") + ".js";
                    } else {
                        var l = "3.6.2";
                        i.src = "https://ucarecdn.com/libs/widget/" + l + "/uploadcare" + (m.forceJQuery ? ".full" : "") + (!1 === m.uploadcareMinify ? "" : ".min") + ".js";
                    }
                    a.head.appendChild(i);
                }
                var o = a.createElement("script");
                (o.type = "text/javascript"),
                    (o.async = !1),
                    (o.src = "https://assets.getuploadkit.com/assets/uploadcare.tab-effects.min.js"),
                    (o.onload = function () {
                        e.uploadcare && e.uploadcare.registerTab("preview", uploadcareTabEffects);
                    }),
                    a.head.appendChild(o),
                    m.manualInit || m.init();
            }),
            a.addEventListener("DOMContentLoaded", function (e) {
                m.runDOMContentLoaded();
            }),
            m && (m.runImmediately || "loading" !== a.readyState) && m.runDOMContentLoaded();
    })(window, document);
//# sourceMappingURL=uploadkit-app.map


